import React, { Component } from "react";
import 'tippy.js/dist/tippy.css';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

class AdminPOIListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formOpen: false,
            formData: {}
        }
    }
    componentDidMount() {
        let serverUrl = 'http://localhost:9000/';
        if (process.env.NODE_ENV === 'development') serverUrl = 'http://localhost:9000/'
        else if (process.env.NODE_ENV === 'production') serverUrl = window.location.protocol + '//' + window.location.host + '/';
        this.setState({ serverUrl: serverUrl, formData: structuredClone(this.props.POI) });


    }
    render() {
        const POI = this.props.POI ? this.props.POI : { name: '', description: '', reward: 200, radius: 500, lat: '', long: '' };

        return (
            <li key={POI._id} className='listItem'>
                <Formik
                    initialValues={{ name: POI.name, description: POI.description, reward: POI.reward, zone: POI.zone, radius: POI.radius, lat: POI.lat, long: POI.long, deletePOI: false }}
                    validationSchema={Yup.object({
                        name: Yup.string()
                            .required('Veuillez renseigner un nom'),
                        description: Yup.string()
                            .required('Veuillez renseigner un nom'),
                        reward: Yup.number()
                            .required('Veuillez renseigner un rang'),
                        zone: Yup.number(),
                        radius: Yup.number(),
                        lat: Yup.string()
                            .required('Veuillez renseigner une latitude'),
                        long: Yup.string()
                            .required('Veuillez renseigner une longitude'),
                    })}
                    onSubmit={(values) => {
                        console.log('submit')
                        this.submitPOI(values);
                    }}>
                    <Form>
                        <h2 className='boatName'> <Field name="name" type="text" placeholder="POI"></Field></h2><br />
                        <Field name="description" type="text" component='textarea'></Field><br />


                        Récompense : <Field name="reward" type="number" placeholder="200"></Field><br />
                        Zone : <Field name="zone" type="number" placeholder="0"></Field><br />
                        Radius : <Field name="radius" type="number" placeholder="500"></Field>



                        <div className='boatInfo'><span><Field name="lat" type="text" placeholder="0"></Field></span>,
                            <span><Field name="long" type="text" placeholder="0"></Field></span></div>

                        <div className="formError">
                            <p><ErrorMessage name="name" /></p>
                            <p><ErrorMessage name="textarea" /></p>
                            <p><ErrorMessage name="reward" /></p>
                            <p><ErrorMessage name="zone" /></p>
                            <p><ErrorMessage name="radius" /></p>
                            <p><ErrorMessage name="lat" /></p>
                            <p><ErrorMessage name="long" /></p>
                            <p><ErrorMessage name="deletePOI" /></p>
                        </div>

                        Delete ? <Field type="checkbox" name="deletePOI" /><br />
                        <input type="submit" value="Valider" />
                    </Form>
                </Formik>
            </li>
        );
    }
    submitPOI(values) {
        console.log(values)
        let changedValues = {}
        let action = '';
        if (this.props.POI) {
            const oldValues = this.props.POI;
            changedValues._id = oldValues._id;

            if (oldValues.name != values.name) changedValues.name = values.name;
            if (oldValues.description != values.description) changedValues.description = values.description;
            if (oldValues.reward != values.reward) changedValues.reward = values.reward;
            if (oldValues.zone != values.zone) changedValues.zone = values.zone;
            if (oldValues.radius != values.zone) changedValues.radius = values.radius;
            if (oldValues.lat != values.lat) changedValues.lat = values.lat;
            if (oldValues.long != values.long) changedValues.long = values.long;

            action = 'updatePOI';
            if (values.deletePOI) {
                action = 'deletePOI';

            }
        } else {
            changedValues = values;
            action = 'createPOI';
        }
        // console.log(changedValues)

        if (Object.keys(changedValues).length > 0) {
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(changedValues)
            }
            fetch(this.state.serverUrl + "admin/" + action, options)
                .then(res => res.json().then(json => {
                    if (json.message === 'success') {
                        console.log(action + ' successful!')
                        this.props.getPOIData();
                    }
                }));
        }
    }


}


export default AdminPOIListItem;
